(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-hubspot"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('contact-triage')) {
    class ContactTriage extends HTMLElement {
      connectedCallback() {
        this.trail = [];
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-go], [data-back], [data-eve]');
          if (!button) return;

          if (button.dataset.go) {
            this.go(button.dataset.go);
          } else if (button.hasAttribute('data-back')) {
            this.show(this.trail.pop() || 'topics');
          } else {
            this.askEve(button.dataset.eve);
          }
        });
      }

      get current() {
        return this.querySelector('[data-step]:not([hidden])').dataset.step;
      }

      go(name, options = {}) {
        this.trail.push(this.current);
        this.show(name, options);
      }

      show(name, { eveUnavailable = false } = {}) {
        this.querySelectorAll('[data-step]').forEach((step) => {
          step.hidden = step.dataset.step !== name;
        });

        const step = this.querySelector(`[data-step="${name}"]`);
        if (name === 'form') {
          step.querySelector('[data-eve-unavailable]').hidden = !eveUnavailable;
          this.loadForm(step.querySelector('[data-hubspot-form]'));
        }
        step.focus({ preventScroll: true });
      }

      // Created on first view rather than page load, so it never renders into a hidden box
      loadForm(target) {
        if (target.dataset.loaded) return;
        target.dataset.loaded = 'true';
        window.hbspt.forms.create({
          portalId: target.dataset.portalId,
          formId: target.dataset.formId,
          region: 'na1',
          target: `#${target.id}`
        });
      }

      // Eve sends the question herself, which prompts sign-in or email verification.
      // If the chat is blocked or switched off, fall back to the form.
      askEve(question) {
        const chat = window.__wbxChat;
        if (chat && typeof chat.ask === 'function') {
          chat.ask(question);
        } else {
          this.go('form', { eveUnavailable: true });
        }
      }
    }

    window.customElements.define('contact-triage', ContactTriage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-guide-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var fmt = function (n) { return '£' + Math.round(n).toLocaleString('en-GB'); };

    function initCalc(root) {
      var years = root.querySelector('[data-wbg-years]');
      var value = root.querySelector('[data-wbg-value]');
      var out = root.querySelector('[data-wbg-out]');
      if (!years || !value || !out) return;
      function run() {
        var y = parseInt(years.value, 10) || 0;
        var v = parseFloat(value.value) || 0;
        if (y < 20) {
          out.innerHTML = '<b>Not covered</b>The long service exemption needs at least 20 years. At ' + y + ' years this is a taxable benefit unless another exemption or a PAYE Settlement Agreement applies.';
          return;
        }
        var cap = y * 50;
        var html = '<b>' + fmt(cap) + ' tax-free</b>That is £50 for each of ' + y + ' years.';
        if (v > 0) {
          html += v < cap
            ? ' Your ' + fmt(v) + ' award is inside the limit.'
            : ' Your ' + fmt(v) + ' award is ' + fmt(v - cap) + ' over, so report that excess on a P11D and pay Class 1A National Insurance on it.';
        }
        out.innerHTML = html;
      }
      years.addEventListener('input', run);
      value.addEventListener('input', run);
      run();
    }

    function initToc() {
      var details = document.querySelector('[data-wbg-toc]');
      if (details && window.matchMedia('(max-width: 959px)').matches) details.removeAttribute('open');
      var links = [].slice.call(document.querySelectorAll('[data-wbg-link]'));
      if (!links.length || !('IntersectionObserver' in window)) return;
      var map = {};
      links.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && map[e.target.id]) {
            links.forEach(function (a) { a.classList.remove('is-active'); });
            map[e.target.id].classList.add('is-active');
          }
        });
      }, { rootMargin: '-120px 0px -65% 0px' });
      Object.keys(map).forEach(function (id) {
        var el = document.getElementById(id);
        if (el) io.observe(el);
      });
    }

    function init() {
      document.querySelectorAll('[data-wbg-calc]').forEach(initCalc);
      initToc();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbox-expandable-split-image"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.shopify-section--wellbox-expandable-split-image');
    if (!section) return;

    section.querySelectorAll('.wellbox-esi__toggle-trigger').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var item = btn.parentElement;
        var wasOpen = item.classList.contains('is-open');
        section.querySelectorAll('.wellbox-esi__toggle').forEach(function(t) {
          t.classList.remove('is-open');
          t.querySelector('.wellbox-esi__toggle-trigger').setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbox-numbered-nav-image"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-nni-play]');
    if (!btn) return;
    var wrap = btn.closest('[data-nni-explainer]');
    var video = wrap && wrap.querySelector('video');
    if (!video) return;
    wrap.classList.add('is-playing');
    video.controls = true;
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  });

  (function() {
    var section = document.querySelector('.shopify-section--wellbox-numbered-nav-image');
    if (!section) return;

    section.querySelectorAll('.wellbox-nni__nav-item').forEach(function(nav) {
      nav.addEventListener('click', function() {
        var targetId = nav.getAttribute('data-nni-target');
        section.querySelectorAll('.wellbox-nni__nav-item').forEach(function(n) { n.classList.remove('is-active'); });
        section.querySelectorAll('.wellbox-nni__detail').forEach(function(d) { d.classList.remove('is-active'); });
        section.querySelectorAll('.wellbox-nni__image-panel').forEach(function(p) { p.classList.remove('is-active'); });
        nav.classList.add('is-active');
        var detail = document.getElementById(targetId);
        if (detail) detail.classList.add('is-active');
        var imgPanel = document.getElementById('nni-img-' + targetId.replace('nni-', ''));
        if (imgPanel) imgPanel.classList.add('is-active');
      });
    });

    section.querySelectorAll('.wellbox-nni__detail').forEach(function(detail) {
      detail.addEventListener('click', function() {
        var id = detail.id;
        section.querySelectorAll('.wellbox-nni__nav-item').forEach(function(n) {
          n.classList.toggle('is-active', n.getAttribute('data-nni-target') === id);
        });
        section.querySelectorAll('.wellbox-nni__detail').forEach(function(d) { d.classList.remove('is-active'); });
        section.querySelectorAll('.wellbox-nni__image-panel').forEach(function(p) { p.classList.remove('is-active'); });
        detail.classList.add('is-active');
        var imgPanel = document.getElementById('nni-img-' + id.replace('nni-', ''));
        if (imgPanel) imgPanel.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbox-sticky-subnav"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var nav = document.getElementById('wellbox-sticky-subnav');
    if (!nav) return;

    var links = nav.querySelectorAll('[data-subnav-link]');
    var anchors = [];

    links.forEach(function(link) {
      var href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        anchors.push({ id: href.substring(1), link: link });
      }
    });

    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var href = link.getAttribute('href');
        if (href && href.startsWith('#')) {
          var target = document.getElementById(href.substring(1));
          if (target) {
            e.preventDefault();
            var offset = nav.offsetHeight + 16;
            var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
          }
        }
      });
    });

    function updateActive() {
      var current = anchors.length > 0 ? anchors[0].id : '';
      var scrollPos = window.scrollY + 200;
      anchors.forEach(function(item) {
        var el = document.getElementById(item.id);
        if (el) {
          var elTop = el.getBoundingClientRect().top + window.scrollY;
          if (scrollPos >= elTop) {
            current = item.id;
          }
        }
      });
      links.forEach(function(link) {
        var href = link.getAttribute('href');
        if (href === '#' + current) {
          link.classList.add('is-active');
        } else {
          link.classList.remove('is-active');
        }
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          updateActive();
          ticking = false;
        });
        ticking = true;
      }
    });

    updateActive();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellbox-tabbed-vertical-image"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.shopify-section--wellbox-tabbed-vertical-image');
    if (!section) return;

    section.querySelectorAll('.wellbox-tvi__tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        section.querySelectorAll('.wellbox-tvi__tab').forEach(function(t) { t.classList.remove('is-active'); });
        section.querySelectorAll('.wellbox-tvi__panel').forEach(function(p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var panel = document.getElementById(tab.getAttribute('data-tvi-panel'));
        if (panel) panel.classList.add('is-active');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
